import { useContext, useEffect, useState } from "react";
import { fetchPropertyByPostalCode } from "../../../services/real-star-api/property/property";
import { propertyAddressByPostalMapping } from "../fields-mapping";
import { useParams } from "react-router-dom";
import { setAlert, setFormState } from "../../../state/action";
import FormContext from "../../../context/form-context";


const useTransactionDetails = () => {
    const {appState,dispatch} = useContext(FormContext);
    const { postalCode } = useParams();

    useEffect( () => {
        const getPropertyDetailsByPostal = async () => {
            try {
                const propertyDetails = await fetchPropertyByPostalCode(postalCode);
                const property = await propertyAddressByPostalMapping(propertyDetails)
    
                dispatch(setFormState({
                    ...appState.formState,
                    mainValues: {
                        ...appState.formState.mainValues,
                        ...property,
                    }
                }));
            } catch (error) {
                dispatch(setAlert({
                    show: true,
                    title: `Error: Postal Code`,
                    body: `${postalCode} does not exist`
                }));
            }
            
        }


        if(postalCode){
            getPropertyDetailsByPostal();
        }
    },[])
}

export default useTransactionDetails;